import { NgModule, ModuleWithProviders } from '@angular/core';
import { WsChatService } from './ws-chat/ws-chat.service';
import { WsPacketService } from './ws-packet/ws-packet.service';
import { WebsocketService } from './websocket/websocket.service';
import { WebsocketConfigService } from './data-studio-ws-config.service';
import { LdsPrebuiltWschatService } from './pre-built/lds-prebuilt-wschat.service';
import { WebsocketConfig } from '../interfaces/all';


@NgModule()
export class DataStudioWsModule {
    static forRoot(config: WebsocketConfig): ModuleWithProviders<DataStudioWsModule> {
        return {
            ngModule: DataStudioWsModule,
            providers: [
                WsChatService,
                WsPacketService,
                WebsocketService,
                LdsPrebuiltWschatService,
                {
                    provide: WebsocketConfigService,
                  useValue: {url: 'wss://v1-linkplus-app.lightwaverf.com'}
                }
            ]
        };
    }
}
